import React, { Component } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );
  }
}

export default class Responsive extends Component {
  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      autoPlay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 5000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div className='slick slicknews'>
        <Slider {...settings}>

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/WOW14.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> April 14, 2025 </div>
              <div className='name'>Time to Eat!</div>
              <div className='content'>
              Does the order in which you eat your food matter?
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW14", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>    

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/WOW13.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> April 07, 2025 </div>
              <div className='name'>IV Therapy</div>
              <div className='content'>
              Should I book an IV Therapy Appointment?
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW13", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>  

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/WOW12.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> October 21, 2024 </div>
              <div className='name'>Vitamin D</div>
              <div className='content'>
              Called a Vitamin, but acts like a Hormone
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW12", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>   

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/WOW11.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> October 07, 2024 </div>
              <div className='name'>Choleterol</div>
              <div className='content'>
              The Good, The Bad, & The Balanced!
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW11", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>  

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/WOW10.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> September 22, 2024 </div>
              <div className='name'>Sleep</div>
              <div className='content'>
              Is your sleep optimal?
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW10", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>   

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/WOW9.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> September 18, 2024 </div>
              <div className='name'>Cold & Flu Season</div>
              <div className='content'>
              Let's protect your body against sickness!
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW9", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>   

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/WOW8.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> September 02, 2024 </div>
              <div className='name'>Seasons Change</div>
              <div className='content'>
              Seasons change ... And so should your diet!
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW8", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>   

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/water.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> June 10, 2024 </div>
              <div className='name'>Electrolytes: Stay Current</div>
              <div className='content'>
              Why electrolytes will keep you charged up this summer
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW7", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/All.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> April 22, 2024 </div>
              <div className='name'>It's Just my Allergies!</div>
              <div className='content'>
              Reaching for the Kleenex and eye drops rather than the sunglasses with warmer weather?
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW6", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>


        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/Migraine.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> April 15, 2024 </div>
              <div className='name'>Migraine</div>
              <div className='content'>
                More than just a bad headache.
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW5", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/Mag.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> April 8, 2024 </div>
              <div className='name'>0mg = Magnesium Deficiency</div>
              <div className='content'>
                Magnesium is one of the most common nutrient deficiencies
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW4", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/Eggs.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> April 01, 2024 </div>
              <div className='name'>Egg-cellent Health</div>
              <div className='content'>
                What health benefits to eggs provide?
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW3", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>

        <CustomSlide className='itm' index={3}>
            <div className='bg'>
              <img
                src="./img/news/Alzheimers.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
           <div className='desc'>
              <div className='date'> March 25, 2024 </div>
              <div className='name'>Forget Me? Not!</div>
              <div className='content'>
                Alzheimer's may be Diabetes Type III
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW2", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={2}>
            <div className='bg'>
              <img
                src="./img/news/Protein.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='date'> March 15, 2024 </div>
              <div className='name'>Protein: The Magic Macro</div>
              <div className='content'>
                Is protein magic? No. But, it does provide many health benfits 
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("WOW1", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>
          
          <CustomSlide className='itm' index={1}>
            <div className='bg'>
              <img
                src="./img/news/NPLEX.png"
                className="img-fluid"
                alt="Imageteam"
              />
            </div>
            <div className='desc'>
              <div className='date'> July 02, 2023</div>
              <div className='name'>Passing NPLEX I & II</div>
              <div className='content'>
                How I successfully passed both NPLEX I & II. 
              </div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("NPLEXblog", "_self")}>
                Read More
              </span>
            </div>
          </CustomSlide>


        </Slider>
      </div>
    );
  }
}
